export default "__VITE_PUBLIC_ASSET__e91f6f9e__"